export default "__VITE_ASSET__CRwQqo44__"